<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Materiały</span>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja materiału</template>
          <template v-else>Dodawanie materiału</template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/ustawienia/materialy')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab title="Dane ogólne" active>
            <h4 class="mb-3 pb-3 border-bottom">
              Dane ogólne
            </h4>

            <validation-observer
              ref="material-form"
              tag="form">
              <div class="form-group">
                <label for="name">
                  Nazwa materiału:
                </label>

                <validation-provider
                  rules="required"
                  name="name"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.name" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </validation-observer>

            <div
              v-if="!allDataLoaded"
              class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>

            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>

          <d-tab title="Kolory materiału">
            <h4 class="mb-3 pb-3 border-bottom d-flex">
              <span>
                Dostępne kolory materiału
              </span>

              <d-button
                theme="success"
                outline
                class="ml-auto"
                @click.prevent="addColor">
                Dodaj kolor
              </d-button>
            </h4>

            <table
              v-if="data.colors.length"
              class="table w-100 mt-3 mb-0">
              <thead>
                <tr>
                  <th>Kolor</th>
                  <th style="width: 100px;">Akcje</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(color, index) of data.colors"
                  :key="'color-' + index">
                  <td class="align-middle">
                    <d-input
                      v-model="color.name" />
                  </td>
                  <td class="align-middle">
                    <d-button
                      theme="danger"
                      @click.prevent="removeColor(index)">
                      Usuń
                    </d-button>
                  </td>
                </tr>
              </tbody>
            </table>

            <d-alert
              v-if="!data.colors.length"
              show
              theme="warning">
              Nie znaleziono dostępnych kolorów dla tego materiału&hellip;
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'material-form',
  computed: {
    allDataLoaded () {
      return this.loaded;
    },
    isEdit () {
      return !!this.$route.params.id;
    }
  },
  data() {
    return {
      data: {
        id: 0,
        name: '',
        colors: []
      },
      loaded: false,
      loadError: false
    };
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
    } else {
      this.loaded = true;
    }
  },
  methods: {
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/materials/item/',
        instanceFields: ['id', 'name', 'colors'],
        loadedKey: 'loaded'
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['material-form'], this.submitForm);
    },
    submitForm () {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = this.isEdit ? '/materials/update/' + this.id : '/materials/store';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano materiał',
        successText: 'Wybrany materiał został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja materiału nie powiodła się. Spróbuj ponownie.',
        successAction: (response) => {
          if (!this.isEdit && response.item && response.item.id) {
            this.$router.push('/ustawienia/materialy/edycja/' + parseInt(response.item.id, 10));
          } else if (this.isEdit) {
            this.loaded = false;
            this.loadItemData();
          } else {
            this.$router.push('/ustawienia/materialy')
          }
        }
      });
    },
    prepareFormDataToSend () {
      let formDataToSend = {
        name: this.data.name,
        colors: this.data.colors.filter(color => color.name !== '')
      };

      return formDataToSend;
    },
    addColor () {
      this.data.colors.push({
        id: 0,
        name: ''
      });
    },
    removeColor (index) {
      this.data.colors.splice(index, 1);
    }
  }
};
</script>
